import { render, staticRenderFns } from "./video-metadata.vue?vue&type=template&id=90ee626e&scoped=true&"
import script from "./video-metadata.vue?vue&type=script&lang=js&"
export * from "./video-metadata.vue?vue&type=script&lang=js&"
import style0 from "./video-metadata.vue?vue&type=style&index=0&id=90ee626e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90ee626e",
  null
  
)

export default component.exports